export const patientRoutes = {
    patientProfile: `/patients/patientProfile/`,
};